<div class="">
  <div class="header-container"></div>
</div>

<section class="servicios-page py-2 mt-0">
  <div class="container py-5">
    <div class="row mb-5 text-center">
      <div class="col-12">
        <h1 class="display-3 fw-bold">Nuestros <span class="text-teal">Servicios</span></h1>
        <p class="lead text-muted mx-auto" style="max-width: 700px;">
          Tecnología de vanguardia diseñada para simplificar tus procesos y maximizar tus ventas.
        </p>
      </div>
    </div>

    @for (s of servicios; track s.id) {
      <div class="row px-0 mx-0 align-items-center mb-100 g-5">
        <div class="col-12 col-lg-6" [class.order-lg-2]="!s.imageLeft">
          <div class="service-visual rounded-4 shadow-lg d-flex align-items-center justify-content-center" 
               [style.backgroundColor]="s.color + '15'"
               [style.border]="'2px solid ' + s.color + '30'">
            <div class="logo">
              <img [src]="s.icono" alt="Centrix Peru">
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-6" [class.order-lg-1]="!s.imageLeft">
          <div class="ps-lg-4">
            <span class="text-uppercase fw-bold ls-1" [style.color]="s.color">{{ s.subtitulo }}</span>
            <h2 class="display-5 fw-bold mt-2 mb-4">{{ s.titulo }}</h2>
            <p class="fs-5 text-muted mb-4">{{ s.descripcion }}</p>
            
            <ul class="list-unstyled mb-5">
              @for (punto of s.puntosClave; track punto) {
                <li class="d-flex align-items-center mb-3">
                  <div class="check-icon me-3 bg-white">
                    <i class="fa-solid fa-check"></i>
                  </div>
                  <span class="fw-medium text-dark">{{ punto }}</span>
                </li>
              }
            </ul>

            <button class="btn btn-lg px-4 py-1 fs-18px fw-bold text-white shadow-sm" 
                    [style.backgroundColor]="s.color" (click)="saberMas(s.url)">
              Saber más &rarr;
            </button>
          </div>
        </div>
      </div>
    }

  </div>
</section>
